export default __webpack_public_path__ + "static/media/rooster.301ff1dd.mp3";